import { atom } from 'jotai';
import { IEmployeeViewModel } from 'Interfaces/IEmployeeConfig';

const userAtom = atom<IEmployeeViewModel>({} as IEmployeeViewModel);
userAtom.debugLabel = 'userAtom';

export default userAtom;
